module.exports = __webpack_public_path__ + "img/uultra.a00872cd.jpg";